/**
 * 补充旅客信息
 */

import { saveOldLocation } from '../../modules/actions';
import { gspCollect } from '@csair/emp-helpers';

export default store => ({
  path: 'addProductShop',
  onEnter(nextState, replace, callback) {
    // gspCollect(
    //   [
    //     '2021-EMP退改-补充旅客信息页面',
    //     '补充旅客信息页面',
    //     '018-000-71001-103',
    //   ],
    //   { 6: '国内' },
    //   process.env.NODE_ENV === 'production'
    // );
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const addProductShop = require('./components/addProductShop').default;
        cb(null, addProductShop);
      },
      'addProductShop'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/addProductShop/index.js